/**
 * Created by Thomas Coppein
 * Date: 21/04/2021
 * Time: 15:05
 */
import Page from '../Page';

class AuthLogin extends Page {
  constructor(params = {}) {
    super(params);
  }
}

export default AuthLogin;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/Auth/AuthLogin.js